import { Box, Button } from "@material-ui/core";
import { FC, useEffect } from "react";
import { useStyles } from "./styles";
import { WeekSelect } from "components/elements/WeekSelect";
import { useDateWeekSelector } from "hooks/useDateWeekSelector";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import { MonthSelect } from "components/elements/MonthSelect";
import { useDispatch } from "react-redux";
import {
  trackerSetDate,
  trackerSetStation,
  trackerSetType,
  getTrackerData,
} from "actions/trackerAction";
import { StationSelect } from "componentsNew/elements/SelectField";
import { YearSelect } from "components/elements/YearSelect";
import { SearchInput } from "componentsNew/elements/SearchInput";

interface PropsType {
  searchValue: string;
  onSearchValueChange: (value: string) => void;
}

const TrackerHead: FC<PropsType> = ({searchValue, onSearchValueChange}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { trackerFilters } = useTypeSelectors((state) => state.trackerTable);

  const handleChangeExternalSelectType = (select: string) => dispatch(trackerSetType(select));
  const handleChangeWeek = (week: string) => dispatch(trackerSetDate({ week }));
  const handleChangeMonth = (month: string) => dispatch(trackerSetDate({ month }));
  const handleChangeYear = (year: string) => dispatch(trackerSetDate({ year }));
  const handleChangeStation = (station: string) => dispatch(trackerSetStation(station));

  const {
    week,
    month,
    year,
    selectType,
    dateCondition,
    dateConditionMonth,
    onWeekReduce,
    onWeekIncrease,
    onMonthReduce,
    onMonthIncrease,
    onTypeExternalChange,
    onYearIncrease,
    onYearReduce,
    dateConditionYear,
  } = useDateWeekSelector({
    defaultWeek: trackerFilters?.date?.week,
    defaultMonth: trackerFilters?.date?.month,
    defaultYear: trackerFilters?.date?.year,
    defaultSelectType: trackerFilters?.selectType,
    onSelectTypeSet: handleChangeExternalSelectType,
    onWeekSet: handleChangeWeek,
    onMonthSet: handleChangeMonth,
    onYearSet: handleChangeYear,
  });

  useEffect(() => {
    const params = {
      station: trackerFilters.station,
      year: year,
      ...(selectType === "month" && { month: +month }),
      ...(selectType === "week" && { week: +week }),
    };
    dispatch(getTrackerData(params));
  }, [week, month, year, trackerFilters.station, selectType, dispatch]);

  return (
    <Box className={classes.trackerHead}>
      <Box className={classes.buttonBox}>
        <Button
          variant={selectType === "year" ? "contained" : "outlined"}
          className={classes.leftButton}
          onClick={() => onTypeExternalChange("year")}
        >
          Year
        </Button>
        <Button
          variant={selectType === "month" ? "contained" : "outlined"}
          className={classes.midButton}
          onClick={() => onTypeExternalChange("month")}
        >
          Monthly
        </Button>
        <Button
          variant={selectType === "week" ? "contained" : "outlined"}
          className={classes.rightButton}
          onClick={() => onTypeExternalChange("week")}
        >
          Weekly
        </Button>
      </Box>
      <Box>
        {selectType === "week" && (
          <WeekSelect
            week={week}
            year={year}
            onNext={onWeekIncrease}
            onPrev={onWeekReduce}
            disabled={dateCondition()}
          />
        )}
        {selectType === "month" && (
          <MonthSelect
            month={month}
            year={year}
            onNext={onMonthIncrease}
            onPrev={onMonthReduce}
            disabled={dateConditionMonth()}
          />
        )}
        {selectType === "year" && (
          <YearSelect
            year={year}
            onNext={onYearIncrease}
            onPrev={onYearReduce}
            disabled={dateConditionYear()}
          />
        )}
      </Box>
      <StationSelect
        value={trackerFilters.station}
        onChange={handleChangeStation}
      />
      <SearchInput value={searchValue} onChange={onSearchValueChange} />
    </Box>
  );
};

export default TrackerHead;
